module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/ps.9092cf62.svg";